<svg
  width="24"
  height="25"
  viewBox="0 0 24 25"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_3498_26694)">
    <path
      d="M11.9996 24.4989C18.6263 24.4989 23.9983 19.1269 23.9983 12.5002C23.9983 5.87347 18.6263 0.501465 11.9996 0.501465C5.37286 0.501465 0.000854492 5.87347 0.000854492 12.5002C0.000854492 19.1269 5.37286 24.4989 11.9996 24.4989Z"
      fill="#4C97E3"
    />
    <path
      d="M9.9012 9.88466L9.90125 15.7515H14.0912C14.0915 15.7515 14.0916 9.88466 14.0916 9.88466H16.6633L12.1398 3.75146C12.1397 3.75119 7.33813 9.88466 7.33813 9.88466H9.9012Z"
      fill="white"
    />
    <path d="M8.50073 17.7515H15.5007V18.7515H8.50073V17.7515Z" fill="white" />
    <path d="M10.0007 20.2515H14.0007V21.2515H10.0007V20.2515Z" fill="white" />
  </g>
  <defs>
    <clipPath id="clip0_3498_26694">
      <rect
        width="23.9974"
        height="23.9974"
        fill="white"
        transform="translate(0.00134277 0.501465)"
      />
    </clipPath>
  </defs>
</svg>
